export class FilesTreeService {
  constructor($http, $rootScope, PermissionService) {
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.permissions = PermissionService;
  }

  load(path, callback) {
    if (!this.permissions.files) return Promise.resolve({});

    if (!this.$rootScope.isPdf) return this.$http.get(`/files/folder-${path? path: ''}`)
      .then(({
        data,
        status
      }) => {
        if (!path) this.data = data;
        if (callback) callback(data);
      });
  }
}



// WEBPACK FOOTER //
// ./src/view/filetree/files-tree.service.js